import { render } from "./FooterSection.vue?vue&type=template&id=6204a778&ts=true"
import script from "./FooterSection.vue?vue&type=script&lang=ts"
export * from "./FooterSection.vue?vue&type=script&lang=ts"

import "./FooterSection.vue?vue&type=style&index=0&id=6204a778&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__